import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	plusOneMinuteNonfinal: {
		id: 'standups.timer.plus-one-minute-nonfinal',
		defaultMessage: '+1 min',
		description: 'The text for the button that adds one minute to the timer',
	},
	playNonfinal: {
		id: 'standups.timer.play-nonfinal',
		defaultMessage: 'Play',
		description: 'The label of the button that plays the timer',
	},
	pauseNonfinal: {
		id: 'standups.timer.pause-nonfinal',
		defaultMessage: 'Pause',
		description: 'The label of the button that pauses the timer',
	},
	stopNonfinal: {
		id: 'standups.timer.stop-nonfinal',
		defaultMessage: 'Stop',
		description: 'The label of the button that stops the timer',
	},
	soundOnNonfinal: {
		id: 'standups.timer.sound-on-nonfinal',
		defaultMessage: 'Sound on',
		description:
			'The label of the button that indicates the sound is on and pressing will mute sound',
	},
	soundOffNonfinal: {
		id: 'standups.timer.sound-off-nonfinal',
		defaultMessage: 'Sound off',
		description:
			'The label of the button that indicates the sound is off and pressing will bring sound on',
	},
});
